import _typeof from "reshow-runtime/es/helpers/typeof";
import { FUNCTION } from 'reshow-constant';

var callFunc = function callFunc(func, args, scope) {
  return FUNCTION === _typeof(func) ? func.apply(scope, args) : func;
};

var defaultCall = function defaultCall(defaultFunc, func, scope) {
  return function () {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return callFunc(func || defaultFunc, args, scope);
  };
};

export default callFunc;
export { defaultCall };